import { ReasonByProductType, ReturnApplication, ReturnReason } from './../../models/ApplicationModel';
import {Component, Input, OnInit, SimpleChanges, Output, EventEmitter} from '@angular/core';
import * as Constants from '../../models/Constants';
import {ApplicationService} from '../../shared/services/application.service';
import {AlertService} from '../../shared/services/alert.service';
import {Router} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import {FileUploaderOptions, FileLikeObject} from 'ng2-file-upload';
import {FileItem, FileUploader} from 'ng2-file-upload';
import {AccountService} from '../../services/account.service';
import {DataVariables} from '../../../environments/app.variables';
import { FIRItem } from '../../models/CommonModels';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ErisLoginService} from '../../services/sso/eris-login.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import {
  formatDisallowedTypeMessage,
  parseUploadApiError,
  PDF_FILE_TOO_LARGE_MESSAGE,
  validatePdfFileBeforeUpload
} from '../../shared/helpers/pdf-upload-validator';

@Component({
  selector: 'app-basic-modal',
  templateUrl: './basic-modal.component.html',
  styleUrls: ['./basic-modal.component.css']
})
export class BasicModalComponent implements OnInit {
  @Input() title: string;
  @Input() buttonLabel: string;
  @Input() applicationId: number;
  @Input() previousApplicationId: number;
  @Input() newApplicationStatus: string;
  @Input() showInspectionActions: boolean;
  @Input() editMode: boolean;
  @Input() fileName: string;
  @Input() comment: string;
  @Input() productTypeName: number;
  @Input() id: number;
  @Input() facilityId: number;
  @Input() isInspectionSubmittedWithDoc: boolean; // use old way of uploading doc instead of odk virtual form
  @Output() statusChanged = new EventEmitter<boolean>(); // to send data to the parent
  firItems: FIRItem[];
  selectedFirItems: FIRItem[] = [];
  selectedSubItems: Array<string> = [];
  constants: any = Constants;
  inspectionResult = false;
  uploadedDocID: number;
  commentInput: string;
  modalRef: BsModalRef;
  reasonByProductType: ReturnReason [];
  selectedReason: number [] = [];
  showCommentBox: boolean = false;
  uploadingDoc = false;

  inspectionUploader: FileUploader;
  uploaderOptions: FileUploaderOptions = {
    'allowedFileType': ['pdf'],
    'maxFileSize': 2 * 1024 * 1024,
    'headers': [{
      name: 'Authorization',
      value: 'Bearer ' + this.accountService.getTokenData()
    }],
    'url': DataVariables.ATTACHMENT_URL
  };
  hasAnotherDropZoneOver = false;
  hasBaseDropZoneOver = false;
  uploadDocTitle = "Upload Inspection Result";

  constructor(private applicationService: ApplicationService, private accountService: AccountService, private alertService: AlertService,
              private router: Router, private spinner: NgxSpinnerService, private modalService: BsModalService,
              private erisLoginService: ErisLoginService, private errorHandlerService: ErrorHandlerService) {
              
              
  }


  ngOnInit() {
    if ((this.showInspectionActions && ! ([Constants.FIR_REQUESTED, Constants.FIR_REQUESTED_AFTER_INSPECTION].includes(this.newApplicationStatus)))) {
      this.inspectionUploadSetting();
    }

    if (this.editMode) {
      this.commentInput = this.comment;
    }
    (<any>jQuery('#metismenu')).metisMenu();
    $(document).ready(function() {
      $('.i-checks').iCheck({ checkboxClass: 'icheckbox_square-green'});
      $('.i-checks').on('ifToggled', event => {
      });
    });

    this.getReturnReasonList();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(this.newApplicationStatus === Constants.LEGACY_FIR_SUBMITTED){
      this.applicationService.getFIRItem(this.previousApplicationId).subscribe(resp => {
        this.firItems = resp;
      });
    }
    else if (this.facilityId) {
      this.applicationService.getFIRItem(this.applicationId).subscribe(resp => {
        this.firItems = resp;
      });
    }
    if (this.editMode || (this.newApplicationStatus === Constants.LICENSE_SUSPENDED || this.newApplicationStatus === Constants.LICENSE_CANCELLED)) {
      this.inspectionUploadSetting();
    }
    if (changes.buttonLabel.previousValue !== changes.buttonLabel.currentValue &&
      this.showInspectionActions && !([Constants.FIR_REQUESTED, Constants.FIR_REQUESTED_AFTER_INSPECTION].includes(this.newApplicationStatus))) {

      if (this.inspectionUploader) {
      this.inspectionUploader.clearQueue();
      }
    }
  }

  getReturnReasonList(){
    this.applicationService.getReturnApplicationReasons(this.productTypeName).subscribe(resp => {
      this.reasonByProductType = resp.map(r => r.reason);
    });
  }

  listMenuClicked(value) {
    value.isExpanded = !value.isExpanded;
  }

  checkboxValueChanged(parentObj, childObj) {
    switch (childObj.name) {

        case 'Region':
            parentObj.subItems.forEach(element => {
              if (element.name === 'Zone' || element.name === 'Woreda' || element.name == 'Sub City') {
                return element.selected = !element.selected;
              }
            });
            break;
        case 'Zone':
            parentObj.subItems.forEach(element => {
              if (element.name === 'Woreda' || element.name == 'Sub City') {
                return element.selected = !element.selected;
              }
            });
            break;
        case 'Sub City':
          parentObj.subItems.forEach(element => {
            if (element.name === 'Woreda') {
              return element.selected = !element.selected;
            }
          });
          break;
        case 'Product Type':
            parentObj.subItems.forEach(element => {
              if (element.name === 'Specific Product'){
                element.selected = !element.selected;
              }
            });// we will not break, let it also select/deselect specific product item
        case 'Specific Product':
          parentObj.subItems.forEach(element =>{
            if (element.name === 'Specific Product Item') {
              return element.selected = !element.selected;
            }
          });
           break;
      }
      if (this.selectedSubItems.indexOf(childObj) === -1) {
        this.selectedSubItems.push(childObj);
      } else {
        this.selectedSubItems.splice(this.selectedSubItems.indexOf(childObj), 1);
      }
  }

  parentCheck(parentObj) {
    parentObj.selected = !parentObj.selected;
    // for (var i = 0; i < parentObj.childList.length; i++) {
    //   parentObj.childList[i].selected = parentObj.selected;
    // }
  }
  commentValChange(val: HTMLInputElement) {}

  inspectionUploadSetting() {
    this.inspectionUploader = new FileUploader(this.uploaderOptions);
    let uploadErrorMessage: string;
    this.inspectionUploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
      $('#applicationModal').modal('hide');
      switch (filter.name) {
        case 'fileSize':
          uploadErrorMessage = PDF_FILE_TOO_LARGE_MESSAGE;
          break;
        case 'fileType':
          uploadErrorMessage = formatDisallowedTypeMessage(item.type || 'unknown');
          break;
        default:
          uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
      }
      this.alertService.error(uploadErrorMessage);
    };

    var referenceId = Constants.INSPECTION_RESULT_REFERENCE_ID;
    if(this.newApplicationStatus == Constants.LICENSE_CANCELLED){
      referenceId = Constants.LICENSE_CANCELLATION_LETTER_REFERENCE_ID;
      this.uploadDocTitle = "Upload Cancellation Letter";
    }else if(this.newApplicationStatus == Constants.LICENSE_SUSPENDED){
      referenceId = Constants.LICENSE_SUSPENSION_LETTER_REFERENCE_ID;
      this.uploadDocTitle = "Upload Suspension Letter";
    }

    this.inspectionUploader.onBuildItemForm = (fileItem: any, form: any) => {
      form.append('TempFolderName', this.accountService.getUserData().username);
      form.append('ApplicationID', this.applicationId);
      form.append('referenceID', referenceId);
      form.append('UserID', this.erisLoginService.getUserId());
     };

    this.inspectionUploader.onErrorItem = (item: FileItem, response: string, status: number) => {
      $('#applicationModal').modal('hide');
      this.alertService.error(parseUploadApiError(response, status));
      this.uploadingDoc = false;
    };

     this.inspectionUploader.onAfterAddingFile = (item: FileItem) => {
        item.withCredentials = false;
        validatePdfFileBeforeUpload(item._file, this.uploaderOptions.maxFileSize).then(validationError => {
          if (validationError) {
            $('#applicationModal').modal('hide');
            this.alertService.error(validationError);
            item.remove();
            return;
          }

          this.uploadingDoc = true;
          this.inspectionUploader.uploadItem(item);
        }).catch(() => {
          $('#applicationModal').modal('hide');
          this.alertService.error('Unable to read the selected file.');
          item.remove();
        });
     };

    this.inspectionUploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 413) {
        this.alertService.error(PDF_FILE_TOO_LARGE_MESSAGE);
      } else if (status === 422) {
        this.alertService.error(parseUploadApiError(response, status));
      } else if (status === 200) {
        response = JSON.parse(response);
        this.uploadedDocID = response.id;
        this.inspectionResult = response.referenceID === Constants.INSPECTION_RESULT_REFERENCE_ID;
      }
      this.uploadingDoc = false;
    };
  }

  strokeColor(position): string {
    switch (position) {
      case 'outer':
        return this.buttonLabel === Constants.PASS ? '#1AB394' : '#ED5565';
      case 'inner':
        return this.buttonLabel === Constants.PASS ? '#60e6c4' : '#ff8893';
      default:
        break;
    }
    return '';
  }

  fileOverBase(e: any): void {
   this.hasBaseDropZoneOver = e;
  }

  checkFIRItemsSelected() {
    if ([Constants.FIR_SUBMITTED,  Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.newApplicationStatus)){
      return this.selectedSubItems.length > 0;
    } else {
      return true;
    }
  }

  toggleShowComment() {
    this.showCommentBox = !this.showCommentBox;
  }

  submitForm(statusCode, comment, selectedReason) {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.spinner.show();
    if (this.buttonLabel === Constants.APPROVE_CLOSE) {
      $('#applicationModal').modal('hide');
      const data = {
        'applicationID': this.applicationId,
        'comment': comment.value
      };
      this.applicationService.generateCertificate(data).subscribe(
        response => {
          this.spinner.hide();
          if (response) {
            this.alertService.success('Certificate generated successfully. Wait 30 seconds to print the certificate.');
            this.statusChanged.emit(true);
            this.router.navigate(['/applications/all']);
            return;
          } else {
            this.alertService.error('Application Update Failed');
            return;
          }
        }, err => {
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(err));
          return;
        });
      return;
    }

    let itemJson: any;

    if (this.firItems != null && this.firItems.length > 0) {
    this.firItems.forEach(firItem => {
      const selectedItems: FIRItem = new FIRItem();
        firItem.subItems.forEach(subItem => {
          if (subItem.selected) {
            selectedItems.name = firItem.name;
            selectedItems.subItems.push(subItem);
          }
        });
        this.selectedFirItems.push(selectedItems);
    });
    itemJson = JSON.stringify(this.selectedFirItems);
  }

    const returnReasonsList = selectedReason.map((reasonId) => {return {reasonId: reasonId}})
    const data = {
      'applicationID': this.applicationId,
      'statusCode': statusCode.value,
      'returnReason': returnReasonsList,
      'comment': comment.value,
      'docID': this.uploadedDocID,
      'id': this.id,
      'editFields': itemJson
    };
    console.log(data)
    // send api
    if (!this.editMode) {
    this.applicationService.changeApplicationStatus(data).subscribe(
      response => {
        this.spinner.hide();
        if (response) {
          $('#applicationModal').modal('hide');
          this.alertService.success('Application Updated Successfully');
          this.statusChanged.emit(true);
          this.router.navigate(['/applications/all']);
        } else {
          $('#applicationModal').modal('hide');
          this.alertService.error('Application Update Failed');
        }
      }, err => {
        this.spinner.hide();
        $('#applicationModal').modal('hide');
        this.alertService.error(this.errorHandlerService.handleApiError(err));  
      });
  } else {
     this.applicationService.changeInspectionInfo(data).subscribe(
      response => {
        this.spinner.hide();
        if (response) {
          $('#applicationModal').modal('hide');
          this.alertService.success('Inspection Result Updated Successfully');
        } else {
          $('#applicationModal').modal('hide');
          this.alertService.error('Inspection Result Update Failed');
        }
      }, err => {
        this.spinner.hide();
        $('#applicationModal').modal('hide');
        this.alertService.error(err);
      }
     );
  }
  }

  showConfirmation(template) {
    $('#applicationModal').removeClass('fade');
    $('#applicationModal').modal('hide');
    $('#applicationModal').addClass('fade');

    this.modalRef = this.modalService.show(template);
  }

  closeModal() {
    this.modalRef.hide();
  }
}
